import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, message, Typography } from 'antd';
import './Signup.css';

const { Text } = Typography;

const backend_url = process.env.REACT_APP_BACKEND_URL;



function Signup(props) {
  const [inputValue, setInputValue] = useState({
    fname: '',
    email: '',
    mobile: '',
    username: '',
    password: '',
    cpassword: ''
  });

  // Update the state when input changes
  const setValue = (e) => {
    const { name, value } = e.target;
    setInputValue((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    // Ensure passwords match
    if (inputValue.password !== inputValue.cpassword) {
      message.error('Passwords do not match');
      return;
    }

    // Show spinner
    props.setLoad(true);

    try {
      console.log("Sending data:", inputValue); // Log the form data before sending

      // const response = await fetch(`http://localhost:8000/api/signup`, {
      const response = await fetch(`${backend_url}/api/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputValue),
      });

      if (response.status === 409) {
        message.error('Email or username already exists');
      } else if (response.status === 201) {
        message.success('Signup successful! Please proceed to login.');
        props.onFlip();

        // Reset input values after successful signup
        setInputValue({
          fname: '',
          email: '',
          mobile: '',
          username: '',
          password: '',
          cpassword: ''
        });
      } else {
        message.error('Signup failed. Please try again.');
      }
    } catch (error) {
      console.error(error);
      message.error('An error occurred. Please try again.');
    } finally {
      // Hide spinner
      props.setLoad(false);
    }
  };

  return (
    <div className="signup">
      <div className="signup-form-container">
        <Form onFinish={handleSubmit} className="signup-form" layout="horizontal">
          
          {/* Form fields */}
          <Form.Item
            label="Name*"
            name="fname"
            rules={[{ required: true, message: 'Please input your name!' }]}
          >
            <Input name="fname" value={inputValue.fname} onChange={setValue} placeholder="Enter your name" />
          </Form.Item>

          <Form.Item
            label="Email*"
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input name="email" value={inputValue.email} onChange={setValue} placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            label="Mobile Number"
            name="mobile"
          >
            <Input name="mobile" value={inputValue.mobile} onChange={setValue} placeholder="Enter your mobile number" />
          </Form.Item>

          <Form.Item
            label="Username*"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input name="username" value={inputValue.username} onChange={setValue} placeholder="Enter your username" />
          </Form.Item>

          <Form.Item
            label="Password*"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password name="password" value={inputValue.password} onChange={setValue} placeholder="Enter your password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password*"
            name="cpassword"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password name="cpassword" value={inputValue.cpassword} onChange={setValue} placeholder="Confirm your password" />
          </Form.Item>

          <div className="flex flex-col items-center">
            <Button type="primary" htmlType="submit" className="signupButton">Sign-Up</Button>
            <Text className="text-black transition duration-300">
              Already have an account?{' '}
              <span onClick={props.onFlip} className="cursor-pointer font-black">Login</span>
            </Text>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Signup;